'use client';

import { observer } from 'mobx-react-lite';
import { useStore } from '@/stores';
import { IconButton, IconButtonProps } from '@/ui';
import { searchSpotlight } from './store';

export const SearchButton = observer(
  (props: Pick<IconButtonProps, 'hiddenFrom' | 'visibleFrom'>) => {
    const store = useStore();

    return (
      <IconButton
        iconName="search"
        onClick={() => searchSpotlight.open()}
        variant="subtle"
        size={store.navbar.collapsed ? 'md' : 'xl'}
        iconSize="lg"
        w={store.navbar.collapsed ? '100%' : undefined}
        {...props}
      />
    );
  }
);
